const getUuid = () => {
    let timestamp = new Date().getTime();
    let performanceTime = (performance && performance.now && performance.now() * 1000) || 0;
  
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      let r = Math.random() * 16;
      if (timestamp > 0) {
        r = (timestamp + r) % 16 | 0;
        timestamp = Math.floor(timestamp / 16);
      } else {
        r = (performanceTime + r) % 16 | 0;
        performanceTime = Math.floor(performanceTime / 16);
      }
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  };
  
  export default getUuid;